import { QRCodeSVG } from "qrcode.react";
import { appUrl } from "@/data/site";

export const AppQr = ({ size = 120, id = "app-qr" }) => (
  <div className="inline-block rounded-md bg-white p-2" data-testid={id}>
    <QRCodeSVG id={id + "-svg"} value={appUrl()} size={size} fgColor="#0F2840" level="M" />
  </div>
);

export function downloadQr(id = "app-qr") {
  const svg = document.getElementById(id + "-svg");
  if (!svg) return;
  const blob = new Blob([new XMLSerializer().serializeToString(svg)], { type: "image/svg+xml" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = "qr-espace-client-familly29.svg";
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 5000);
}
